import { render, staticRenderFns } from "./pdf-export-button.vue?vue&type=template&id=3572c0ec&scoped=true"
import script from "./pdf-export-button.vue?vue&type=script&lang=js"
export * from "./pdf-export-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3572c0ec",
  null
  
)

export default component.exports